import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';
import { switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad
{
    /**
     * Constructor
     */
    constructor(
        private _authService: AuthService,
        private _router: Router
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Can activate
     *
     * @param route
     * @param state
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean
    {
        // const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
        // return this._check(redirectUrl);

        return this._check(route);
    }

    /**
     * Can activate child
     *
     * @param childRoute
     * @param state
     */
    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
    {
        // const redirectUrl = state.url === '/sign-out' ? '/' : state.url;
        // return this._check(redirectUrl);

        return this._check(childRoute);
    }

    /**
     * Can load
     *
     * @param route
     * @param segments
     */
    canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean
    {
        // return this._check('/');
        return this._check(null);

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Check the authenticated status
     *
     * @param activatedRouteSnapshot
     * @private
     */
    private _check(activatedRouteSnapshot: ActivatedRouteSnapshot): Observable<boolean>
    {
        // Check the authentication status
        return this._authService.check()
                   .pipe(
                       switchMap((authenticated) => {

                           // If the user is not authenticated...
                           if ( !authenticated )
                           {
                               if (activatedRouteSnapshot) {
                                   const mode = activatedRouteSnapshot.queryParams['mode'];

                                   if (mode === 'resetPassword') {
                                       // Redirect to the reset password page
                                       this._router.navigate(['reset-password'], { queryParams: activatedRouteSnapshot.queryParams });
                                       return of(false);
                                   }
                                   else if (mode === 'verifyEmail') {
                                       // Redirect to the sign-in page
                                       this._router.navigate(['sign-in'], { queryParams: activatedRouteSnapshot.queryParams });
                                       return of(false);
                                   }
                               }

                               // Redirect to the sign-in page
                               this._router.navigate(['sign-in']);

                               // this._router.navigate(['sign-in'], {queryParams: {redirectURL}});

                               // Prevent access
                               return of(false);
                           }

                           // Reset password page will handle the user being logged in already
                           const mode = activatedRouteSnapshot.queryParams['mode'];
                           if (mode === 'resetPassword') {
                               // Redirect to the reset password page
                               this._router.navigate(['reset-password'], { queryParams: activatedRouteSnapshot.queryParams });
                               return of(false);
                           }

                           // Allow access
                           return of(true);
                       })
                   );
    }
}
